// extracted by mini-css-extract-plugin
export var container = "NodeWideServiceCard-module--container--a5bdb";
export var image = "NodeWideServiceCard-module--image--60a4a";
export var image__container = "NodeWideServiceCard-module--image__container--30800";
export var link = "NodeWideServiceCard-module--link--83f23";